import React from 'react';
import { Link } from 'react-router-dom';
import { MapPin, Phone, Mail, Clock, Heart, Sparkles } from 'lucide-react';
import { images, restaurantInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-stone-900 text-stone-200 relative overflow-hidden">
      {/* Decorative elements */}
      <div className="absolute top-0 left-0 w-64 h-64 bg-emerald-500/5 rounded-full -translate-x-1/2 -translate-y-1/2" />
      <div className="absolute bottom-0 right-0 w-96 h-96 bg-emerald-500/5 rounded-full translate-x-1/2 translate-y-1/2" />
      
      <div className="max-w-7xl mx-auto px-6 py-16 relative">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo & Description */}
          <div className="lg:col-span-1">
            <img 
              src={images.logo} 
              alt="Ravintola Data" 
              className="h-20 w-auto mb-4"
            />
            <p className="text-stone-400 text-sm leading-relaxed mb-4">
              Kotiruokaa sydämellä. Kotkalainen lounasravintola, jossa ruoka tehdään itse alusta alkaen.
            </p>
            <div className="flex items-center gap-2 text-emerald-400">
              <Heart className="w-4 h-4" />
              <span className="font-handwritten text-lg">Tervetuloa!</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-emerald-400" />
              Sivut
            </h3>
            <nav className="flex flex-col gap-2">
              <Link to="/" className="text-stone-400 hover:text-emerald-400 transition-colors text-sm hover:translate-x-1 inline-block transform">Etusivu</Link>
              <Link to="/lounas" className="text-stone-400 hover:text-emerald-400 transition-colors text-sm hover:translate-x-1 inline-block transform">Lounas</Link>
              <Link to="/kahvila" className="text-stone-400 hover:text-emerald-400 transition-colors text-sm hover:translate-x-1 inline-block transform">Kahvila</Link>
              <Link to="/pitopalvelu" className="text-stone-400 hover:text-emerald-400 transition-colors text-sm hover:translate-x-1 inline-block transform">Pitopalvelu</Link>
              <Link to="/tarina" className="text-stone-400 hover:text-emerald-400 transition-colors text-sm hover:translate-x-1 inline-block transform">Tarina</Link>
              <Link to="/yhteystiedot" className="text-stone-400 hover:text-emerald-400 transition-colors text-sm hover:translate-x-1 inline-block transform">Yhteystiedot</Link>
            </nav>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-emerald-400" />
              Yhteystiedot
            </h3>
            <div className="flex flex-col gap-3">
              <a href={`https://maps.google.com/?q=${restaurantInfo.address}`} target="_blank" rel="noopener noreferrer" className="flex items-start gap-3 text-stone-400 hover:text-emerald-400 transition-colors text-sm group">
                <MapPin className="w-4 h-4 mt-0.5 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span>{restaurantInfo.address}</span>
              </a>
              <a href={`tel:${restaurantInfo.phone}`} className="flex items-center gap-3 text-stone-400 hover:text-emerald-400 transition-colors text-sm group">
                <Phone className="w-4 h-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span>{restaurantInfo.phone}</span>
              </a>
              <a href={`mailto:${restaurantInfo.email}`} className="flex items-center gap-3 text-stone-400 hover:text-emerald-400 transition-colors text-sm group">
                <Mail className="w-4 h-4 flex-shrink-0 group-hover:scale-110 transition-transform" />
                <span>{restaurantInfo.email}</span>
              </a>
            </div>
          </div>

          {/* Opening Hours */}
          <div>
            <h3 className="text-white font-semibold text-lg mb-4 flex items-center gap-2">
              <Sparkles className="w-4 h-4 text-emerald-400" />
              Aukioloajat
            </h3>
            <div className="flex flex-col gap-3 text-sm">
              <div className="flex items-start gap-3 text-stone-400">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0" />
                <div>
                  <p className="text-emerald-400 font-medium">Lounas</p>
                  <p>Ma-Pe {restaurantInfo.lunchHours.weekdays}</p>
                </div>
              </div>
              <div className="flex items-start gap-3 text-stone-400">
                <Clock className="w-4 h-4 mt-0.5 flex-shrink-0 opacity-0" />
                <div>
                  <p className="text-emerald-400 font-medium">Kahvila</p>
                  <p>Ma-Pe {restaurantInfo.cafeHours.weekdays}</p>
                </div>
              </div>
              <p className="text-stone-500 text-xs mt-2 bg-stone-800 px-3 py-2 rounded-lg">
                Resq ruuat klo 15 asti
              </p>
            </div>
          </div>
        </div>

        {/* Bottom bar */}
        <div className="mt-12 pt-8 border-t border-stone-800 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-stone-500 text-sm">
            © {new Date().getFullYear()} Ravintola Data. Kaikki oikeudet pidätetään.
          </p>
          <p className="text-stone-500 text-sm flex items-center gap-2">
            Tehty <Heart className="w-4 h-4 text-red-500" /> Kotkassa
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
